import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { useLocation } from 'react-use';
import { parse } from 'query-string';
import { useRouting } from '@alycecom/hooks';

import AuthLoading from '../../../../components/Shared/AuthLoading';
import { setCodeError, codeParamsRequest } from '../../store/code.actions';

const ErrorPage = () => {
  const dispatch = useDispatch();
  const go = useRouting();
  const {
    params: { code },
  } = useRouteMatch('/error/:code');

  const { search } = useLocation();
  const { hashid: hashId = null, draftId = undefined, campaignId = undefined } = parse(search);
  if (hashId || draftId || campaignId) {
    dispatch(codeParamsRequest({ hashId, code, draftId, campaignId }));
  }
  dispatch(setCodeError({ code }));

  go('/code');

  return <AuthLoading />;
};

export default ErrorPage;
